export const taxDocumentRoute = {
  TAX_DOCUMENT_LIST: '/tax-document/list',
  TAX_DOCUMENT_SETTING: '/setting/tax-document'
};
